<template>
  <div class="merchant" v-if="joinType == 4">
    <div class="first">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">健康商城商家入驻招募</div>
      </div>
      <div>
        <div class="topcont">
          您是否正在寻找一个更广阔的销售渠道，提升您的品牌知名度和产品销量？
        </div>
        <div class="topcont">
          您是否希望与更多的消费者分享您的健康理念和优质产品？
        </div>
        <div class="topcont">
          如果是的话，那么我们的健康商城将为您提供一个理想的平台！
        </div>
      </div>
      <div class="info">
        作为一家专注于健康领域的在线商城，我们致力于为消费者提供高品质、安全、有效的健康产品和服务。我们拥有庞大的用户群体和专业的运营团队，为商家提供全方位的支持和服务。
      </div>
      <div style="margin-top: 0.3rem">
        <div class="topTip">成为我们的合作商家，您将享受到以下优势</div>
        <div class="list">
          <div class="item_advant" v-for="(item, index) in list" :key="index">
            <div style="display: flex; align-items: center">
              <img
                style="width: 0.49rem; height: 0.3rem"
                :src="item.image"
                alt=""
              />
              <div class="name_advant">{{ item.title }}</div>
            </div>
            <div class="con_advant">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="second">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">商家入驻流程</div>
      </div>
      <div class="flowImg">
        <div>
          <img class="step" src="../../../assets/images/apply.png" alt="" />
          <div class="stepWord">01 提交资料</div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div>
          <img class="step" src="../../../assets/images/audit.png" alt="" />
          <div class="stepWord">02 平台审核</div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div>
          <img
            class="step"
            src="../../../assets/images/completeInfo.png"
            alt=""
          />
          <div class="stepWord">03 完善信息</div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div>
          <img class="step" src="../../../assets/images/shop.png" alt="" />
          <div class="stepWord">04 店铺上线</div>
        </div>
      </div>
      <div class="connection">
        <div>
          <div class="con_cont">
            如果您对我们的商家入驻招募计划感兴趣，请立即联系我们，了解更多详情。让我们携手合作，共同打造一个健康、繁荣的生态环境，为消费者提供更好的健康产品和服务！
          </div>
          <div class="con_person">联系方式：王经理</div>
        </div>
        <div style="text-align: center">
          <div class="qrcode">
            <img
              style="width: 1.71rem; height: 1.77rem"
              src="../../../assets/images/wxCode.png"
              alt=""
            />
          </div>
          <div class="addWx">（扫码加微信）</div>
        </div>
      </div>
    </div>
    <div class="submit">
      <div class="button" @click="submitform">我要入驻</div>
    </div>
  </div>
</template>

<script>
import one from "../../../assets/images/01.png";
import two from "../../../assets/images/02.png";
import three from "../../../assets/images/03.png";
import four from "../../../assets/images/04.png";
import five from "../../../assets/images/05.png";
import six from "../../../assets/images/06.png";
import seven from "../../../assets/images/07.png";
import eight from "../../../assets/images/08.png";
export default {
  name: "",
  props: {
    joinType: {
      type: Number,
    },
  },
  data() {
    return {
      list: [
        {
          image: one,
          title: "极速开店",
          content: "入驻方便，秒审秒开，商家完全自主运营。",
        },
        {
          image: two,
          title: "费用减免",
          content: "0元试运营，0元平台使用费。",
        },
        {
          image: three,
          title: "海量用户",
          content: "享受健康商城庞大的用户群体，拓宽您产品的销售渠道。",
        },
        {
          image: four,
          title: "品牌身份标识",
          content: "旗舰店/专营店/工厂店/药店。",
        },
        {
          image: five,
          title: "新商家流量加持",
          content: "平台2倍流量加速新商家进行推广，全网电商矩阵整合营销。",
        },
        {
          image: six,
          title: "运营支持",
          content: "专业运营团队陪跑，包括店铺装修、产品上架、营销活动策划等。",
        },
        {
          image: seven,
          title: "数据报表",
          content:
            "展示提供详细的销售数据和用户反馈，帮助您更好地了解市场需求和产品优化方向。",
        },
        {
          image: eight,
          title: "官方培训课堂",
          content: "免费带你学电商，小白变高手。",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    submitform() {
      this.$router.push({
        name: "apply",
        query: {
          mch_type: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.merchant {
  padding: 0.81rem 3.6rem 0;
  .first {
    .info {
      margin-top: 0.2rem;
      font-family: OPPOSans, OPPOSans;
      font-weight: 700;
      font-size: 0.26rem;
      color: #232323;
    }
    .topTip {
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.26rem;
      color: #232323;
      margin-bottom: 0.14rem;
    }
    .topcont {
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.26rem;
      color: #232323;
      position: relative;
      margin-left: 0.16rem;
      margin-bottom: 0.05rem;
      &::before {
        content: "";
        width: 0.07rem;
        height: 0.07rem;
        background: #4089fe;
        position: absolute;
        top: 50%;
        left: -0.16rem;
        transform: translateY(-50%);
        border-radius: 50%;
      }
    }
    .list {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      .item_advant {
        width: 2.86rem;
        height: 1.68rem;
        background: #f4f7ff;
        border-radius: 0.04rem;
        margin-top: 0.18rem;
        padding: 0.17rem 0.14rem 0 0.14rem;
        box-sizing: border-box;
        &:not(:nth-of-type(4n)) {
          margin-right: 0.15rem;
        }
        .name_advant {
          font-family: OPPOSans, OPPOSans;
          font-weight: 700;
          font-size: 0.24rem;
          color: #4089fe;
          margin-left: 0.1rem;
        }
        .con_advant {
          font-family: OPPOSans, OPPOSans;
          font-weight: normal;
          font-size: 0.18rem;
          color: #999cb0;
          margin-top: 0.17rem;
        }
      }
    }
  }
  .second {
    margin-top: 0.43rem;
    .flowImg {
      display: flex;
      align-items: center;
      .step {
        width: 2.28rem;
        height: 1.62rem;
      }
      .stepWord {
        margin-top: 0.1rem;
        margin-left: 0.5rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.24rem;
        color: #232323;
      }
      .point {
        margin: 0 0.43rem;
        margin-top: -0.4rem;
      }
    }
    .connection {
      margin-top: 0.72rem;
      display: flex;
      justify-content: space-between;
      width: 12rem;
      height: 3.2rem;
      padding: 0.74rem 1.02rem 0 0.7rem;
      box-sizing: border-box;
      background: #fcfbff;
      .con_cont {
        width: 6.71rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: 600;
        font-size: 0.26rem;
        color: #232323;
      }
      .con_person {
        margin-top: 0.25rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.24rem;
        color: #232323;
      }
      .qrcode {
        width: 1.83rem;
        height: 1.83rem;
        line-height: 1.83rem;
        background: #ffffff;
        border-radius: 0.12rem;
        border: 0.03rem solid #4089fe;
        text-align: center;
      }
      .addWx {
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.18rem;
        color: #495a7b;
        margin-top: 0.1rem;
      }
    }
  }
  .bigTitle {
    display: flex;
    align-items: center;
    margin-bottom: 0.36rem;
    .line {
      width: 0.08rem;
      height: 0.42rem;
      background: #4089fe;
      border-radius: 0.04px;
    }
    .topic {
      margin-left: 0.22rem;
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.4rem;
      color: #232323;
    }
  }
  .submit {
    text-align: center;
    margin-top: 0.62rem;
    .button {
      margin: 0 auto;
      width: 2.4rem;
      height: 0.6rem;
      line-height: 0.6rem;
      background: #4089fe;
      border-radius: 0.3rem;
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.28rem;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
